import * as React from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { ButtonGroup, Typography } from '@mui/material';
import { AppPrimaryButton } from 'shared/components/AppComponents';
// import { SwitchComp } from 'shared/components/Switch';

const OverrideGlobalSavingModal: React.FC<Props> = React.forwardRef(
    (
        { callbackClosingModal, callbackOpenModal, callbackFinishOverride },
        ref
    ): React.ReactElement => {
        const [open, setOpen] = React.useState(false);
        const [isSaved] = React.useState<boolean>(false);

        /**
         * handle open modal
         */
        const handleOpen = React.useCallback((): void => {
            setOpen(true);
            if (typeof callbackOpenModal === 'function') callbackOpenModal();
        }, [callbackOpenModal]);

        /**
         * handle close modal
         */
        const handleClose = React.useCallback((): void => {
            if (!isSaved) {
                setOpen(false);
                if (typeof callbackClosingModal === 'function')
                    callbackClosingModal();
            }
        }, [callbackClosingModal, isSaved]);

        const handleSavingModal = React.useCallback(() => {
            if (typeof callbackFinishOverride === 'function') {
                callbackFinishOverride();
            }
            setOpen(false);
        }, [callbackFinishOverride]);

        React.useImperativeHandle(
            ref,
            () => ({
                setClose: () => {
                    handleClose();
                },
                setOpen: () => {
                    handleOpen();
                },
            }),
            [handleOpen, handleClose]
        );
        return (
            <Box>
                <Modal
                    disableEscapeKeyDown={isSaved}
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    disableScrollLock
                >
                    <Box className="container-document-modal-rework">
                        <Typography variant="h2" id="parent-modal-title">
                            Global Template is already in active state. Would
                            you like to override it?
                        </Typography>
                        <Box className="action-tab-selection-rework-detail">
                            <ButtonGroup
                                className="button-group-action-selection-rework"
                                variant="text"
                                aria-label="outlined primary button group"
                            >
                                <AppPrimaryButton
                                    testid="no-rework-button"
                                    title="No"
                                    className="btn-small no"
                                    onClick={handleClose}
                                />
                                <AppPrimaryButton
                                    testid="yes-rework-button"
                                    title="Yes"
                                    disabled={!document}
                                    className="btn-small"
                                    onClick={handleSavingModal}
                                />
                            </ButtonGroup>
                        </Box>
                    </Box>
                </Modal>
            </Box>
        );
    }
);

export default OverrideGlobalSavingModal;
